const types = {
  FETCHPASSAGEPASSVALIDATION: "FETCHPASSAGEPASSVALIDATION",
  EDITPASSAGEPASSVALIDATION: "EDITPASSAGEPASSVALIDATION",
  CREATEPASSAGEPASSVALIDATION: "CREATEPASSAGEPASSVALIDATION",
  EXPORT_PASSAGEPASS_RATES_SUCCESS: "EXPORT_PASSAGEPASS_RATES_SUCCESS",
};
export default types;
